import type { ReactNode } from 'react';
import { usePhone } from '@/lib/responsive';
/** Keep long guidance available without consuming a phone panel's footer. */
export function ResponsiveHelp({ label, children }: { label: string; children: ReactNode }) {
  return usePhone() ? (
    <details className="responsive-help">
      <summary>{label}</summary>
      {children}
    </details>
  ) : (
    <>{children}</>
  );
}
